import __NS_DYNAMIC_REACT_CONTENT___0 from "./talkdesk-chatbot.strings/content.default.js";
import { Content, createScopedReactContentImporter } from "packages/react-content/runtime";
const NS_DYNAMIC_REACT_CONTENT_MANAGER = createScopedReactContentImporter(undefined, {
  "default": () => __NS_DYNAMIC_REACT_CONTENT___0
});
import { createElement, useEffect } from 'react';
import { ChatContainer, ChatNetspendContainer, ChatDesktopIcon, ChatNetspendDesktopIcon, ChatMobileIcon, ChatNetspendMobileIcon } from './talkdesk-chatbot.ccm.css';
import { TalkdeskChatIcons, TalkdeskNetspendChatIcons } from './icons';
import { useHttpQuery } from 'packages/http-client/react';
import { createGetBrandingRequest, createGetConfigurationRequest } from 'apps/acp/packages/webapi';
import { TalkdeskChatbotPlugin } from 'packages/talkdesk-chatbot/plugin';
export const useTalkdeskChatbotAnchor = callback => {
  return {
    href: 'javascript:void(0)',
    onClick: () => {
      var _a;

      callback && callback();

      if ((_a = window.talkDeskWebChat) === null || _a === void 0 ? void 0 : _a.toggle) {
        window.talkDeskWebChat.toggle();
      }
    }
  };
};
export const TalkdeskCustomChatButton = ({
  leftIconColor,
  rightIconColor,
  authed
}) => {
  var _a, _b;

  const netspendBrand = 'netspend_unauthenticated_default';
  const brand = useHttpQuery(createGetBrandingRequest());
  const isNetspendBrand = netspendBrand === ((_b = (_a = brand) === null || _a === void 0 ? void 0 : _a.brand) === null || _b === void 0 ? void 0 : _b.id);
  const DesktopIcon = TalkdeskChatIcons.chat;
  const MobileIcon = TalkdeskChatIcons.chatMobile;
  const NetspendIcon = TalkdeskNetspendChatIcons.chatNetspend; // reinitialize talkdesk sdk with post login touchpointid

  const {
    'talkdesk.chatbot.touchpoint.id': touchpointId
  } = useHttpQuery(createGetConfigurationRequest());
  useEffect(() => {
    if (!sessionStorage.getItem('td_chat_reset') && authed) {
      window.TalkdeskChatSDK = null; // Manual cleanup instead of destroy()

      const existingContainer = document.getElementById('tdWebchat');

      if (existingContainer) {
        existingContainer.remove();
      }

      window.talkDeskWebChat = null;
      new TalkdeskChatbotPlugin(true, touchpointId);
      sessionStorage.setItem('td_chat_reset', 'true');
    }

    if (!authed) {
      sessionStorage.setItem('pre_login_touchpoint_id', touchpointId || '');
    }
  }, [authed, touchpointId]);
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Manual cleanup on page unload
      const existingContainer = document.getElementById('tdWebchat');

      if (existingContainer) {
        existingContainer.remove();
      }

      window.talkDeskWebChat = null;
    }; // Add the event listener when the component mounts


    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  return createElement(Content, {
    hash: "32d17893ef9d0c4cd54821b148a29bad",
    devVariables: {},
    componentsAndExpressions: [() => isNetspendBrand && createElement(ChatNetspendContainer.div, {
      onClick: () => {
        var _a;

        if ((_a = window.talkDeskWebChat) === null || _a === void 0 ? void 0 : _a.toggle) {
          window.talkDeskWebChat.toggle();
        }
      }
    }, createElement(ChatNetspendDesktopIcon.i, null, createElement(NetspendIcon, {
      width: "31",
      height: "31"
    })), createElement(ChatNetspendMobileIcon.i, null, createElement(NetspendIcon, {
      width: "25",
      height: "25"
    }))), () => !isNetspendBrand && createElement(ChatContainer.div, {
      onClick: () => {
        var _a;

        if ((_a = window.talkDeskWebChat) === null || _a === void 0 ? void 0 : _a.toggle) {
          window.talkDeskWebChat.toggle();
        }
      }
    }, createElement(ChatDesktopIcon.i, null, createElement(DesktopIcon, {
      leftIcon: leftIconColor,
      rightIcon: rightIconColor
    })), createElement(ChatMobileIcon.i, null, createElement(MobileIcon, {
      leftIcon: leftIconColor,
      rightIcon: rightIconColor
    })))],
    importer: NS_DYNAMIC_REACT_CONTENT_MANAGER
  });
};